import {EntityModel} from "@fedeltapointofsale/data-client";
import {MyreportData} from "./myreport.data";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class MyreportEntityModel extends EntityModel<MyreportData> {
    constructor(injector: Injector) {
        super(injector, MyreportData);
    }

    override canCreateEntity(): Promise<boolean> {
        return Promise.resolve(false);
    }
}
